import { createContext, useContext, useEffect, useState } from "react";
import api, { tokenStore } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=user
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    (async () => {
      // If no token in storage, skip the call
      if (!tokenStore.get()) {
        setUser(false);
        setChecking(false);
        return;
      }
      try {
        const me = await api.authMe();
        setUser(me);
      } catch (e) {
        if (e?.response?.status === 401 && tokenStore.getRefresh()) {
          try {
            const r = await api.authRefresh();
            if (r?.access_token) tokenStore.set(r.access_token);
            const me = await api.authMe();
            setUser(me);
          } catch {
            tokenStore.clear();
            setUser(false);
          }
        } else {
          setUser(false);
        }
      } finally {
        setChecking(false);
      }
    })();
  }, []);

  const login = async (email, password, remember) => {
    const u = await api.authLogin({ email, password, remember });
    // Store tokens for header-based auth
    if (u?.access_token) tokenStore.set(u.access_token);
    if (u?.refresh_token) tokenStore.setRefresh(u.refresh_token);
    setUser(u);
    return u;
  };

  const register = async (data) => api.authRegister(data);

  const logout = async () => {
    try { await api.authLogout(); } catch {}
    tokenStore.clear();
    setUser(false);
  };

  const isAdmin = user && (user.role === "admin" || user.role === "owner" || user.is_owner === true);

  return (
    <AuthContext.Provider value={{ user, checking, login, register, logout, setUser, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
